import { ResourcesConfig } from 'aws-amplify';
import { environment } from '../../../environments/environment';

export const AMPLIFY_CONFIG: ResourcesConfig = {
  API: {
    GraphQL: {
      endpoint: environment.amplify.graphqlEndpoint,
      region: environment.amplify.region,
      defaultAuthMode: environment.amplify.defaultAuthMode,
      apiKey: environment.amplify.apiKey,
    }
  }
};
